import { Reducer } from "redux";

import {
    BLOGS_BLOCK_USER_SUCCESS,
    BLOGS_LOAD_USER_GROUP_MEMBERSHIPS_SUCCESS,
    BlogsBlockUserSuccessAction,
    BlogsLoadUserGroupMembershipsSuccessAction,
} from "@/mk2/apps/blogs/containers/BlogsShared/BlogsShared.actions";
import { tupdate } from "@/mk2/helpers/types";

export interface UserGroupsState {
    memberships: number[];
    blockedUserIds: number[];
}

export const initialuserGroupsState: UserGroupsState = {
    memberships: [],
    blockedUserIds: [],
};

type BlogsSharedActions = BlogsLoadUserGroupMembershipsSuccessAction | BlogsBlockUserSuccessAction;

const reducer: Reducer<UserGroupsState, BlogsSharedActions> = (
    state = initialuserGroupsState,
    action,
) => {
    switch (action.type) {
        case BLOGS_LOAD_USER_GROUP_MEMBERSHIPS_SUCCESS:
            return tupdate(state, {
                memberships: action.memberships,
            });

        case BLOGS_BLOCK_USER_SUCCESS:
            return tupdate(state, {
                blockedUserIds: [...state.blockedUserIds, action.userId],
            });

        default:
            return state;
    }
};

export default reducer;
